module.exports = __webpack_public_path__ + "img/idivia.96c7ebf2.png";